"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var kendo_react_buttons_1 = require("@progress/kendo-react-buttons");
var kendo_react_dropdowns_1 = require("@progress/kendo-react-dropdowns");
var kendo_react_intl_1 = require("@progress/kendo-react-intl");
var operators_1 = require("./operators");
var messages_1 = require("../messages");
/**
 * @hidden
 */
var Expression = /** @class */ (function (_super) {
    __extends(Expression, _super);
    function Expression() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onFieldChange = function (event) {
            var nextFieldName = event.value.name;
            var nextField = _this.props.fields.find(function (f) { return f.name === nextFieldName; });
            var prevFilter = _this.props.filter;
            var operator = (nextField && !nextField.operators.some(function (o) { return o.operator === prevFilter.operator; })) ?
                nextField.operators[0].operator : prevFilter.operator;
            var nextFilter = {
                field: nextFieldName,
                operator: operator
            };
            if (!operators_1.unaryOperator(operator)) {
                nextFilter.value = operators_1.stringOperator(operator) ? '' : null;
            }
            _this.triggerOnFilterChange(prevFilter, nextFilter, event);
        };
        _this.onOperatorChange = function (event) {
            var operator = event.value.operator;
            var prevFilter = _this.props.filter;
            var nextFilter;
            if (operators_1.unaryOperator(operator)) {
                var value = prevFilter.value, prevFilterNoValue = __rest(prevFilter, ["value"]);
                nextFilter = __assign({}, prevFilterNoValue, { operator: operator });
            }
            else {
                nextFilter = __assign({}, prevFilter, { operator: operator });
            }
            _this.triggerOnFilterChange(prevFilter, nextFilter, event);
        };
        _this.onInputChange = function (event) {
            var prevFilter = _this.props.filter;
            var nextFilter = event.nextFilter;
            if (operators_1.unaryOperator(nextFilter.operator)) {
                var field = _this.props.fields.find(function (f) { return f.name === nextFilter.field; });
                nextFilter = __assign({}, nextFilter, { operator: (field && field.operators[0].operator) || nextFilter.operator });
            }
            _this.triggerOnFilterChange(prevFilter, nextFilter, event);
        };
        _this.triggerOnFilterChange = function (prevFilter, nextFilter, event) {
            var changeEvent = {
                prevFilter: prevFilter,
                nextFilter: nextFilter,
                syntheticEvent: event.syntheticEvent,
                nativeEvent: event.nativeEvent,
                target: _this
            };
            _this.props.onChange.call(undefined, changeEvent);
        };
        _this.onFilterRemove = function (event) {
            var removeEvent = {
                filter: _this.props.filter,
                syntheticEvent: event.syntheticEvent,
                nativeEvent: event.nativeEvent,
                target: _this
            };
            _this.props.onRemove.call(undefined, removeEvent);
        };
        return _this;
    }
    Expression.prototype.render = function () {
        var _a = this.props, fields = _a.fields, filter = _a.filter;
        var field = fields.find(function (f) { return f.name === filter.field; });
        var locService = kendo_react_intl_1.provideLocalizationService(this);
        var operators = ((field && field.operators) || [])
            .map(function (o) { return (__assign({}, o, { text: locService.toLanguageString(o.text, messages_1.messages[o.text] || o.text) })); });
        return (React.createElement("div", { className: "k-filter-toolbar" },
            React.createElement(kendo_react_buttons_1.Toolbar, { keyboardNavigation: false },
                React.createElement(kendo_react_buttons_1.ToolbarItem, { className: "k-filter-field" },
                    React.createElement(kendo_react_dropdowns_1.DropDownList, { className: "k-filter-dropdown", data: fields, textField: "label", value: fields.find(function (f) { return f.name === filter.field; }), onChange: this.onFieldChange })),
                React.createElement(kendo_react_buttons_1.ToolbarItem, { className: "k-filter-operator" },
                    React.createElement(kendo_react_dropdowns_1.DropDownList, { data: operators, textField: "text", value: operators.find(function (o) { return o.operator === filter.operator; }), onChange: this.onOperatorChange })),
                React.createElement(kendo_react_buttons_1.ToolbarItem, { className: "k-filter-value" }, field && React.createElement(field.filter, { filter: filter, onFilterChange: this.onInputChange })),
                React.createElement(kendo_react_buttons_1.ToolbarItem, null,
                    React.createElement(kendo_react_buttons_1.Button, { title: locService.toLanguageString(messages_1.filterClose, messages_1.messages[messages_1.filterClose]), icon: "close", look: "flat", onClick: this.onFilterRemove })))));
    };
    Expression.propTypes = {
        filter: PropTypes.object.isRequired,
        fields: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired,
        onRemove: PropTypes.func.isRequired
    };
    return Expression;
}(React.Component));
exports.Expression = Expression;
kendo_react_intl_1.registerForLocalization(Expression);
//# sourceMappingURL=Expression.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-data-tools@3.18.0_bwv2g72eb344voeanxti7iyzje/~/@progress/kendo-react-data-tools/dist/npm/filter/Expression.js
// module id = 297
// module chunks = 0